import * as React from 'react';
import { SVGProps } from 'react';

const IconGradientsSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M7 0H5v6H3v7h2v3h2v-5H5V8h2V0ZM9 0v5h2v4H9v7h2v-5h2V3h-2V0H9Z" />
  </svg>
);
export default IconGradientsSizeS;
